import { useMemo } from 'react';
import { usePublishedFeatureArticles } from '../../hooks/usePublishedFeatureArticles';
import {
  landingFeatureImagePosition,
  splitLandingFeatures,
} from '../../lib/landingFeatures';
import { SiteFadeInMount } from '../SiteFadeIn';
import { FeatureArticleLarge } from './FeatureArticleLarge';
import { ProductFeaturesSection } from '../ProductFeaturesSection';

export function LandingFeatureArticles() {
  const { articles, loading } = usePublishedFeatureArticles();
  const { large, small } = useMemo(() => splitLandingFeatures(articles), [articles]);

  if (loading) {
    return null;
  }

  if (large.length === 0 && small.length === 0) {
    return null;
  }

  return (
    <SiteFadeInMount>
      {large.length > 0 && (
        <div className="flex flex-col gap-30 pt-30">
          {large.map((article, index) => (
            <FeatureArticleLarge
              key={article.slug}
              article={article}
              imagePosition={landingFeatureImagePosition(index)}
            />
          ))}
        </div>
      )}

      {small.length > 0 && (
        <div className="pt-30">
          <ProductFeaturesSection articles={small} />
        </div>
      )}
    </SiteFadeInMount>
  );
}
